import React from 'react';
import VehicleHub from './VehicleHub';

const config = {
  // Blog guides about this model, rendered as the hub's spoke links. Posts
  // whose own target is this hub's query ("buy/used <model> taxi Delhi")
  // are deliberately left out — linking them would build a competitor.
  guides: [
    'innova-crysta-resale-value-delhi-2026',
    'innova-crysta-maintenance-cost-per-km',
    'cng-kit-cost-innova-crysta-delhi',
    'fortuner-vs-innova-crysta-taxi-comparison',
    'ertiga-vs-innova-7-seater-taxi-comparison',
    'sell-innova-crysta-taxi-best-price-india',
    'buy-innova-crysta-taxi-bangalore',
  ],
  slug: '/innova-crysta-commercial-taxi-delhi',
  brand: 'Toyota',
  model: 'Innova Crysta',
  displayName: 'Toyota Innova Crysta',
  breadcrumbLabel: 'Innova Crysta Commercial Taxi — Delhi',
  seoTitle: 'Toyota Innova Crysta Commercial Taxi for Sale — Delhi NCR',
  seoDescription: 'Buy used Toyota Innova Crysta commercial taxis in Delhi NCR. Verified BST listings with commercial RC, yellow plate, and transparent pricing.',
  keywords: 'Innova Crysta commercial taxi Delhi, used Innova Crysta for sale Delhi, Innova Crysta yellow plate Delhi, buy Innova Crysta taxi Delhi NCR, Innova Crysta resale value Delhi 2026, commercial Innova Crysta price, Innova Crysta taxi operator Delhi',
  h1: 'Toyota Innova Crysta Commercial Taxi for Sale in Delhi NCR',
  answerCapsule: 'Used Toyota Innova Crysta commercial taxis in Delhi NCR are typically priced between ₹8 lakh and ₹18 lakh depending on year and mileage. The Innova Crysta is the most in-demand 7-seater commercial vehicle in Delhi due to its reliability, diesel efficiency, and high resale value. Buy Sell Taxi lists verified Innova Crysta units with commercial RC transfer support.',
  specs: [
    ['Category', 'MPV / 7-Seater Commercial Taxi'],
    ['Engine', '2.4L Diesel (149 bhp) / 2.7L Petrol (164 bhp)'],
    ['Fuel Type', 'Diesel / Petrol'],
    ['Seating', '7–8 Seats'],
    ['Transmission', 'Manual & Automatic'],
    ['Boot Space', '300 litres'],
    ['Mileage', '12–15 km/l (Diesel)'],
    ['Commercial Permit', 'All India Tourist Permit available'],
    ['Typical Use', 'Outstation taxi, airport cab, fleet operator'],
  ],
  priceData: [
    ['2018', '1,80,000 km', '₹8.5L – ₹11L', 'Good'],
    ['2019', '1,40,000 km', '₹10L – ₹13L', 'Very Good'],
    ['2020', '1,00,000 km', '₹12L – ₹15L', 'Excellent'],
    ['2021', '70,000 km',   '₹14L – ₹17L', 'Excellent'],
    ['2022', '50,000 km',   '₹16L – ₹19L', 'Like New'],
  ],
  whyPoints: [
    'Best-in-class diesel mileage among 7-seaters — ideal for long outstation runs from Delhi.',
    'High resale value: an Innova Crysta loses value slower than almost any commercial vehicle in India.',
    'Spacious cabin and large boot make it the #1 choice for airport transfers and corporate fleets.',
    'Easily obtainable All India Tourist Permit (AITP) for inter-state taxi operations.',
    'Wide service network across Delhi NCR — Gurugram, Noida, Faridabad, Ghaziabad.',
  ],
  faqs: [
    {
      q: 'What is the resale value of an Innova Crysta commercial taxi in Delhi in 2026?',
      a: 'A 2019 Toyota Innova Crysta with commercial RC and around 1.5 lakh km typically sells for ₹10–13 lakh in Delhi NCR in 2026. Well-maintained units with service history and clean documents command a premium. Prices have held firm due to strong demand from fleet operators and outstation taxi aggregators.',
    },
    {
      q: 'What documents are needed for commercial RC transfer of an Innova Crysta in Delhi?',
      a: 'For commercial RC transfer in Delhi you need: original RC book, Form 29 and Form 30 (signed by seller), valid insurance with commercial endorsement, NOC from financier (if loan), fitness certificate, pollution (PUC) certificate, and route permit or All India Tourist Permit. Buy Sell Taxi assists buyers with the full RC transfer process.',
    },
    {
      q: 'How long does commercial RC transfer take in Delhi?',
      a: 'Commercial RC transfer in Delhi typically takes 15–30 working days once all documents are correctly submitted to the RTO. The process involves form submission, verification, and issuance of the new RC. Buy Sell Taxi\'s team can guide you through every step to avoid delays.',
    },
    {
      q: 'Is the Innova Crysta diesel or petrol better for taxi use in Delhi?',
      a: 'The diesel variant (2.4L GD) is far more popular for commercial taxi use in Delhi due to its fuel efficiency of 12–15 km/l and lower per-km running costs. However, note that private diesel vehicles above 2000cc are banned in Delhi for private registration. For commercial yellow-plate taxis, both variants are available.',
    },
    {
      q: 'Can I convert a private Innova Crysta to a commercial taxi in Delhi?',
      a: 'Yes, but the conversion process involves: applying for a transport vehicle fitness certificate at a Delhi RTO, converting the registration from private (white plate) to commercial (yellow plate), and obtaining a taxi permit. The process requires a physical inspection of the vehicle. Buy Sell Taxi recommends buying a vehicle that already has commercial RC to save time and cost.',
    },
  ],
};

const InnovaCrystaHub = () => <VehicleHub config={config} />;

export default InnovaCrystaHub;
